/* La Clé du 16 – accueil : comparateur avant / après, vidéo, nuancier de portes et carte des arrondissements.
   La porte de l'en-tête a son propre script dans la section (il doit s'exécuter avant le premier affichage). */
(function () {
  'use strict';

  /* Avant / après : glisser (souris, doigt) ou flèches du clavier sur le curseur */
  document.querySelectorAll('[data-lc-ba]').forEach(function (fig) {
    var frame = fig.querySelector('.lc-ba__frame');
    var range = fig.querySelector('.lc-ba__range');
    if (!frame || !range) return;
    var dragging = false, down = null;
    function set(v) {
      v = Math.max(0, Math.min(100, v));
      range.value = Math.round(v);
      frame.style.setProperty('--pos', v + '%');
    }
    function fromEvent(e) {
      var r = frame.getBoundingClientRect();
      set(((e.clientX - r.left) / r.width) * 100);
    }
    function start(e) {
      dragging = true;
      if (frame.setPointerCapture) { try { frame.setPointerCapture(e.pointerId); } catch (err) {} }
      fromEvent(e);
    }
    range.style.pointerEvents = 'none';
    range.addEventListener('input', function () { set(+range.value); });
    frame.addEventListener('pointerdown', function (e) {
      down = { x: e.clientX, y: e.clientY, moved: false };
      /* souris : on suit tout de suite ; doigt : on attend un geste horizontal pour laisser défiler la page */
      if (e.pointerType === 'mouse') start(e);
    });
    frame.addEventListener('pointermove', function (e) {
      if (dragging) { fromEvent(e); return; }
      if (!down) return;
      var dx = Math.abs(e.clientX - down.x), dy = Math.abs(e.clientY - down.y);
      if (dx > 6 || dy > 6) down.moved = true;
      if (dx > 6 && dx > dy) start(e);
    });
    frame.addEventListener('pointerup', function (e) {
      if (!dragging && down && !down.moved) fromEvent(e);
      dragging = false; down = null;
    });
    ['pointercancel', 'lostpointercapture'].forEach(function (t) {
      frame.addEventListener(t, function () { dragging = false; down = null; });
    });
    set(+range.value || 50);
  });

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Vidéos : sans son, en boucle, lancées seulement quand elles sont visibles ;
     avec « réduire les animations », elles restent arrêtées et gardent leurs commandes. */
  var vids = Array.prototype.slice.call(document.querySelectorAll('[data-lc-video] video'));
  if (vids.length) {
    vids.forEach(function (v) {
      v.muted = true; v.setAttribute('muted', '');
      v.playsInline = true; v.setAttribute('playsinline', '');
      v.loop = true; v.removeAttribute('autoplay');
    });
    var setMode = function () {
      vids.forEach(function (v) {
        v.controls = reduce.matches;
        if (reduce.matches) v.pause();
      });
    };
    setMode();
    if (reduce.addEventListener) reduce.addEventListener('change', setMode);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          if (en.isIntersecting && !reduce.matches) {
            if (v.preload === 'none') v.preload = 'auto';
            var pr = v.play();
            if (pr && pr.catch) pr.catch(function () {});
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { threshold: 0.35 });
      vids.forEach(function (v) { io.observe(v); });
    }
  }

  /* Nuancier : boutons précédent / suivant quand la rangée de photos dépasse l'écran */
  document.querySelectorAll('[data-lc-nu]').forEach(function (list) {
    var sec = list.closest('section');
    var nav = sec ? sec.querySelector('[data-lc-nu-nav]') : null;
    if (!nav) return;
    var prev = nav.querySelector('[data-dir="-1"]');
    var next = nav.querySelector('[data-dir="1"]');
    var tick = false;
    function update() {
      tick = false;
      var max = list.scrollWidth - list.clientWidth;
      nav.hidden = max < 8;
      prev.disabled = list.scrollLeft < 8;
      next.disabled = list.scrollLeft > max - 8;
    }
    function ask() { if (!tick) { tick = true; requestAnimationFrame(update); } }
    [prev, next].forEach(function (b) {
      b.addEventListener('click', function () {
        list.scrollBy({ left: +b.getAttribute('data-dir') * list.clientWidth * 0.8, behavior: reduce.matches ? 'auto' : 'smooth' });
      });
    });
    list.addEventListener('scroll', ask, { passive: true });
    window.addEventListener('resize', ask);
    window.addEventListener('load', ask);
    update();
  });

  /* Carte : survol / focus d'un arrondissement = plaque de rue + liste synchronisée */
  var map = document.querySelector('[data-lc-map]');
  if (map) {
    var svg = map.querySelector('svg');
    var tip = map.querySelector('[data-lc-tip]');
    var vb = svg.viewBox.baseVal;
    var labels = {};
    svg.querySelectorAll('.lc-map__labels text').forEach(function (t) { labels[t.getAttribute('data-n')] = t; });
    var areas = {};
    svg.querySelectorAll('.lc-map__a').forEach(function (a) { areas[a.getAttribute('data-n')] = a; });
    var chips = {};
    document.querySelectorAll('[data-lc-arr] a').forEach(function (a) { chips[a.getAttribute('data-n')] = a; });
    var current = null;

    function on(n) {
      if (current && current !== n) off();
      current = n;
      var a = areas[n];
      if (!a) return;
      a.classList.add('is-on');
      if (labels[n]) labels[n].classList.add('is-on');
      if (chips[n]) chips[n].classList.add('is-on');
      var x = parseFloat(a.getAttribute('data-x'));
      var y = parseFloat(a.getAttribute('data-y'));
      var sw = svg.getBoundingClientRect();
      var mw = map.getBoundingClientRect();
      tip.style.left = (sw.left - mw.left + (x - vb.x) / vb.width * sw.width) + 'px';
      tip.style.top = (sw.top - mw.top + (y - vb.y) / vb.height * sw.height - 10) + 'px';
      tip.querySelector('[data-tip-num]').innerHTML = n + '<sup>' + (n === '1' ? 'er' : 'e') + '</sup> Arr<sup>t</sup>';
      tip.querySelector('[data-tip-name]').textContent = a.getAttribute('data-name');
      tip.classList.add('is-on');
    }
    function off() {
      if (!current) return;
      var n = current;
      current = null;
      if (areas[n]) areas[n].classList.remove('is-on');
      if (labels[n]) labels[n].classList.remove('is-on');
      if (chips[n]) chips[n].classList.remove('is-on');
      tip.classList.remove('is-on');
    }
    function bind(el, n) {
      el.addEventListener('mouseenter', function () { on(n); });
      el.addEventListener('mouseleave', off);
      el.addEventListener('focus', function () { on(n); });
      el.addEventListener('blur', off);
    }
    Object.keys(areas).forEach(function (n) { bind(areas[n], n); });
    Object.keys(chips).forEach(function (n) { bind(chips[n], n); });
  }
})();
